// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.is-uppercase {\n  text-transform: uppercase;\n}\ninput.is-uppercase::-webkit-input-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase::-moz-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase:-moz-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase:-ms-input-placeholder {\n  text-transform: none;\n}\nselect.select-width {\n  min-width: 15em;\n}\n.multiselect__tag {\n  margin: 2px;\n}\n.multi-module-select {\n  max-width: 18vw;\n}", ""]);
// Exports
module.exports = exports;
